module.exports = __webpack_public_path__ + "img/Bhair01.3e308d14.png";